export default __webpack_public_path__ + "static/media/1.f9dafb5e.jpg";